<template>
  <div class="tw-relative tw-mt-10">
    <section class="tw-mb-10">
      <incidents-list />
    </section>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";

import IncidentsList from "@/modules/PhishTitan/views/Common/Incidents/Overview/IncidentsList.vue";
import { EXTERNAL_DOCS_LINKS } from "@/constants/externalDocsLinks";
import { TitleOptions } from "@/store/pageMeta.store";
import { usePageMetaStore } from "@/store/pageMeta.store";

const { t } = useI18n();
const pageMetaStore = usePageMetaStore();

const setPageTitle = (options: TitleOptions) =>
  pageMetaStore.setPageTitle(options);
setPageTitle({
  title: t("incidents-legend"),
  info: {
    docsLink: EXTERNAL_DOCS_LINKS.ES_INCIDENTS,
    text: t("incidents-page"),
  },
});
</script>
